var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { getRGBColor } from 'utils/layout';
import HeadBand from './HeadBand.js';
import styles from './PromotionHeadBand.module.css';
export const PromotionHeadBand = (_a) => {
    var _b;
    var { saveCSSVarColorsWithotPrefix, promotion, design, content, extraParams, onApply, onButtonClick } = _a, rest = __rest(_a, ["saveCSSVarColorsWithotPrefix", "promotion", "design", "content", "extraParams", "onApply", "onButtonClick"]);
    const intl = useIntl();
    const { useTailwindPrefix, className, children } = rest;
    function mod_getRGBColor(hex, name) {
        if (saveCSSVarColorsWithotPrefix) {
            return getRGBColor(hex, name, '');
        }
        return getRGBColor(hex, name);
    }
    function getStyleOptions() {
        const values = [];
        const bg = design === null || design === void 0 ? void 0 : design.textStyle.find((s) => s.type === 'BACKGROUND');
        values.push(mod_getRGBColor((bg === null || bg === void 0 ? void 0 : bg.backgroundColor) || '#ffffff', 'alerts-headband-background'));
        const text = design === null || design === void 0 ? void 0 : design.textStyle.find((s) => s.type === 'BODY');
        values.push(mod_getRGBColor((text === null || text === void 0 ? void 0 : text.color) || '#565a5c', 'alerts-headband-a11y'));
        const button = design === null || design === void 0 ? void 0 : design.textStyle.find((s) => s.type === 'BUTTON');
        values.push(mod_getRGBColor((button === null || button === void 0 ? void 0 : button.color) || '#333333', 'alerts-headband-button-a11y'));
        values.push(mod_getRGBColor((button === null || button === void 0 ? void 0 : button.backgroundColor) || '#ffffff', 'alerts-headband-button-background'));
        values.push(mod_getRGBColor((button === null || button === void 0 ? void 0 : button.borderColor) || '#333333', 'alerts-headband-button-border'));
        return values;
    }
    function drawButton() {
        if (content) {
            if (content.buttonUrl && content.buttonUrl !== '') {
                const url = (() => {
                    const qs = new URLSearchParams(extraParams !== null && extraParams !== void 0 ? extraParams : {}).toString();
                    if (!qs)
                        return content.buttonUrl;
                    return `${content.buttonUrl}${content.buttonUrl.includes('?') ? '&' : '?'}${qs}`;
                })();
                const buttonClasses = classNames(styles.button, {
                    'block mt-2 px-3 py-1.5 bg-alerts-headband-button-background text-alerts-headband-button-a11y border border-alerts-headband-button-border hover:bg-alerts-headband-button-background/90 transition': !useTailwindPrefix,
                    'tw-block tw-mt-2 tw-px-3 tw-py-1.5 tw-bg-alerts-headband-button-background tw-text-alerts-headband-button-a11y tw-border tw-border-alerts-headband-button-border hover:tw-bg-alerts-headband-button-background/90 tw-transition': useTailwindPrefix,
                });
                if (onButtonClick) {
                    return (_jsx("button", Object.assign({ type: "button", className: buttonClasses, onClick: () => __awaiter(this, void 0, void 0, function* () {
                            yield onButtonClick();
                            window.open(url, '_blank', 'noopener,noreferrer');
                        }) }, { children: content.buttonText || intl.formatMessage({ id: 'common.popup.ok' }) })));
                }
                return (_jsx("a", Object.assign({ href: url, target: "_blank", rel: "noopener noreferrer", className: buttonClasses }, { children: content.buttonText || intl.formatMessage({ id: 'common.popup.ok' }) })));
            }
            else if (promotion && promotion.code) {
                return (_jsx("button", Object.assign({ type: "button", className: classNames(styles.button, {
                        'block mt-2 px-3 py-1.5 bg-alerts-headband-button-background text-alerts-headband-button-a11y border border-alerts-headband-button-border hover:bg-alerts-headband-button-background/90 transition': !useTailwindPrefix,
                        'tw-block tw-mt-2 tw-px-3 tw-py-1.5 tw-bg-alerts-headband-button-background tw-text-alerts-headband-button-a11y tw-border tw-border-alerts-headband-button-border hover:tw-bg-alerts-headband-button-background/90 tw-transition': useTailwindPrefix,
                    }), onClick: () => __awaiter(this, void 0, void 0, function* () {
                        yield (onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick());
                        onApply(promotion, extraParams !== null && extraParams !== void 0 ? extraParams : {});
                    }) }, { children: content.buttonText || intl.formatMessage({ id: 'common.popup.applyCode' }) })));
            }
        }
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `:root {
               ${(_b = getStyleOptions()) === null || _b === void 0 ? void 0 : _b.join(' ')}
            }` }), _jsx(HeadBand, Object.assign({}, rest, ((design === null || design === void 0 ? void 0 : design.displayPositionType) === 'TOP'
                ? { position: 'top' }
                : (design === null || design === void 0 ? void 0 : design.displayPositionType) === 'BOTTOM'
                    ? { position: 'bottom' }
                    : {}), { className: classNames(className, {
                    'bg-alerts-headband-background text-alerts-headband-a11y': !useTailwindPrefix,
                    'tw-bg-alerts-headband-background tw-text-alerts-headband-a11y': useTailwindPrefix,
                }) }, { children: _jsxs(HeadBand.Container, { children: [_jsx(HeadBand.CloseButton, { className: classNames({
                                'text-alerts-headband-a11y/50 hover:text-alerts-headband-a11y hover:bg-white/10 mt-1': !useTailwindPrefix,
                                'tw-text-alerts-headband-a11y/50 hover:tw-text-alerts-headband-a11y hover:tw-bg-white/10 tw-mt-1': useTailwindPrefix,
                            }) }), (content === null || content === void 0 ? void 0 : content.title) && (_jsx("h2", Object.assign({ className: classNames({
                                'text-[16px] font-bold mb-1': !useTailwindPrefix,
                                'tw-text-[16px] tw-font-bold tw-mb-1': useTailwindPrefix,
                            }) }, { children: content.title }))), (content === null || content === void 0 ? void 0 : content.description) && _jsx("div", { dangerouslySetInnerHTML: { __html: content.description } }), children, drawButton()] }) }))] }));
};
export default PromotionHeadBand;
